export default "__VITE_ASSET__BUAH3OzN__"